/* CHUM Application
========================================================================== */
$(function() {
	/* Application */
	//app.example();

	/* Template */
	template.component.elementLink();
	template.component.menu();
	template.component.pageSelector();
});

$(window).load(function() {
	flexbox_fallback('.row--flex .box', 0);
	template.component.pageBackground();
});

var resizeTimer;
$(window).resize(function() {
	clearTimeout(resizeTimer);
	resizeTimer = setTimeout(function (e) {
		flexbox_fallback('.row--flex .box', 0);
		template.component.pageBackground();
	}, 250);
});
